'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.phone = exports.password = exports.lt = exports.email = exports.required = undefined;

var _validator = require('validator');

var _validator2 = _interopRequireDefault(_validator);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var required = function required(value) {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return 'require';
  }
};

var email = function email(value) {
  if (!_validator2.default.isEmail(value)) {
    return value + ' is not a valid email.';
  }
};

var phone = function phone(value) {
  if (!_validator2.default.isMobilePhone(value, "de-DE")) {
    return value + ' is not a valid phone.';
  }
};

var lt = function lt(value, props) {
  // get the maxLength from component's props
  if (!value.toString().trim().length > props.maxLength) {
    // Return jsx
    return React.createElement('span', {
      className: 'error'
    }, 'The value exceeded ', props.maxLength, ' symbols.');
  }
};

var password = function password(value, props, components) {
  // NOTE: Tricky place. The 'value' argument is always current component's value.
  // So in case we're 'changing' let's say 'password' component - we'll compare it's value with 'confirm' value.
  // But if we're changing 'confirm' component - the condition will always be true
  // If we need to always compare own values - replace 'value' with components.password[0].value and make some magic with error rendering.
  if (value !== components['confirm'][0].value) {
    // components['password'][0].value !== components['confirm'][0].value
    // 'confirm' - name of input
    // components['confirm'] - array of same-name components because of checkboxes and radios
    return React.createElement('span', {
      className: 'error'
    }, 'Passwords are not equal.');
  }
};

exports.required = required;
exports.email = email;
exports.lt = lt;
exports.password = password;
exports.phone = phone;